import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ArticlePage } from './pages/ArticlePage';
import { ArticlesListPage } from './pages/ArticlesListPage';
import { ChangelogListPage } from './pages/ChangelogListPage';
import { ChangelogPage } from './pages/ChangelogPage';
import { FeaturesListPage } from './pages/FeaturesListPage';
import { FeaturePage } from './pages/FeaturePage';
import { IntegrationsListPage } from './pages/IntegrationsListPage';
import { PricingPage } from './pages/PricingPage';
import { PowerPage } from './pages/PowerPage';
import { McpPage } from './pages/McpPage';
import { DocsListPage } from './pages/DocsListPage';
import { SagaPage } from './pages/SagaPage';
import { AdminAuthProvider } from './auth/AdminAuthProvider';
import { AdminAuthGuard } from './auth/AdminAuthGuard';
import { AdminLoginPage } from './pages/admin/AdminLoginPage';
import { AdminAuthCallbackPage } from './pages/admin/AdminAuthCallbackPage';
import { AdminArticleListPage } from './pages/admin/AdminArticleListPage';
import { AdminArticleFormPage } from './pages/admin/AdminArticleFormPage';
import '../styles/index.css';
import { initPostHog } from './lib/posthog';
import { initSentry } from './lib/sentry';
import { prefetchSiteContent } from './lib/prefetchSiteContent';

initSentry();
initPostHog();
prefetchSiteContent();

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/features" element={<FeaturesListPage />} />
      <Route path="/features/:slug" element={<FeaturePage />} />
      <Route path="/integrations" element={<IntegrationsListPage />} />
      <Route path="/mcp" element={<McpPage />} />
      <Route path="/power" element={<PowerPage />} />
      <Route path="/enterprise" element={<Navigate to="/power" replace />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/articles" element={<ArticlesListPage />} />
      <Route path="/articles/:slug" element={<ArticlePage />} />
      <Route path="/changelog" element={<ChangelogListPage />} />
      <Route path="/changelog/:slug" element={<ChangelogPage />} />
      <Route path="/guides" element={<Navigate to="/docs" replace />} />
      <Route path="/saga" element={<SagaPage />} />
      <Route path="/docs" element={<DocsListPage />} />
      <Route path="/docs/:slug" element={<DocsListPage />} />

      <Route
        path="/admin/*"
        element={
          <AdminAuthProvider>
            <Routes>
              <Route index element={<Navigate to="/admin/articles" replace />} />
              <Route path="login" element={<AdminLoginPage />} />
              <Route path="auth/callback" element={<AdminAuthCallbackPage />} />
              <Route
                path="articles"
                element={
                  <AdminAuthGuard>
                    <AdminArticleListPage />
                  </AdminAuthGuard>
                }
              />
              <Route
                path="articles/new"
                element={
                  <AdminAuthGuard>
                    <AdminArticleFormPage />
                  </AdminAuthGuard>
                }
              />
              <Route
                path="articles/:id/edit"
                element={
                  <AdminAuthGuard>
                    <AdminArticleFormPage />
                  </AdminAuthGuard>
                }
              />
            </Routes>
          </AdminAuthProvider>
        }
      />
    </Routes>
  </BrowserRouter>,
);
